import { render } from "./WorkspaceInfo.vue?vue&type=template&id=6c55362d&scoped=true"
import script from "./WorkspaceInfo.vue?vue&type=script&lang=js"
export * from "./WorkspaceInfo.vue?vue&type=script&lang=js"

import "./WorkspaceInfo.vue?vue&type=style&index=0&id=6c55362d&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c55362d"]])

export default __exports__